/**
 * MpsAudit front configuration.
 *
 * Single place to tune the front behaviour of the MpsAudit module without
 * touching the service/components:
 *   - endpoint prefix (must match the back `mpsaudit.routes_prefix`)
 *   - whether router navigations are logged as events
 *   - which columns the history table shows
 *   - which fields the detail dialog header shows
 *   - whether the "raw JSON" toggle is available in the detail dialog
 */

/** History table columns (order preserved). `fullname` = author's user_fullname. */
export type MpsAuditHistoryColumn =
  | 'date'
  | 'igg'
  | 'fullname'
  | 'email'
  | 'action'
  | 'entity'
  | 'name'
  | 'id'
  | 'detail';

/** Detail dialog header fields (order preserved). */
export type MpsAuditDetailHeaderField = 'date' | 'igg' | 'fullname' | 'email' | 'entity' | 'name' | 'id' | 'action';

export interface MpsAuditConfig {
  /**
   * Optional prefix prepended before the fixed `/mpsaudit/...` routes.
   * Final URL = `${environment.api.host}${endpointPrefix}/mpsaudit/log-event`.
   *
   *   ''      → http://host/mpsaudit/log-event      (default)
   *   '/api'  → http://host/api/mpsaudit/log-event
   *
   * No trailing slash. Must match the back-end `mpsaudit.routes_prefix`.
   */
  endpointPrefix: string;

  /** When false, logEvent() (incl. auto PAGE_NAVIGATION) is a no-op. */
  logEventEnabled: boolean;

  /** Columns rendered by the history table, in order. */
  historyColumns: MpsAuditHistoryColumn[];

  /** Fields rendered in the detail dialog header, in order. */
  detailHeaderFields: MpsAuditDetailHeaderField[];

  /** When true, the detail dialog exposes the "show raw JSON" toggle. */
  showRawJson: boolean;
}

export const MPS_AUDIT_CONFIG: MpsAuditConfig = {
  // '' → /mpsaudit/... ; set '/api' to get /api/mpsaudit/...
  endpointPrefix: '',

  logEventEnabled: false,

  historyColumns: ['date', 'igg', 'fullname', 'action', 'name', 'detail'],

  detailHeaderFields: ['date', 'igg', 'email', 'entity'],

  showRawJson: false,
};
